const sortData = (field: string, data: Array<any>, dir?: string) => {
  let sortedRecord = [...data];
  if (dir && dir === "desc") {
    sortedRecord = sortedRecord.sort((a: any, b: any) => {
      if (typeof b[field] === "number") {
        return b[field] - a[field];
      } else {
        return (b[field] || "").toLowerCase() > (a[field] || "").toLowerCase()
          ? 1
          : -1;
      }
    });
  } else {
    sortedRecord = sortedRecord.sort((a: any, b: any) => {
      if (typeof b[field] === "number") {
        return a[field] - b[field];
      } else {
        return (a[field] || "").toLowerCase() > (b[field] || "").toLowerCase()
          ? 1
          : -1;
      }
    });
  }

  return sortedRecord;
};

const groupByFields = (array: any, f: any) => {
  /*
    params description :
        f : function which returnf the array of fields 
        e.g. :  (item) => {
            return [itemField1, itemField2];
        }

        array : array of data to group e.g. : [{...}, {...}]       
    */

  var groups: any = {};
  array.forEach((o: any) => {
    var group = JSON.stringify(f(o));
    groups[group] = groups[group] || [];
    groups[group].push(o);
  });
  return Object.keys(groups).map(group => {
    return groups[group];
  });
};

export interface DivideByKeyResultTypes<T> {
  letter: string;
  data: T[];
}

const divideByKey_OLD = (field: string, array: any) => {
  let map = array.reduce((p: any, c: any) => {
    let char = c[field].charAt(0).toUpperCase();
    p[char] = [].concat(p[char] || [], c);
    return p;
  }, {});

  let result = Object.keys(map).map(k => ({
    letter: k,
    data: map[k],
  }));
  result = sortData("letter", result);
  return result;
};

const divideByKey = <T>(
  field: keyof T,
  array: T[],
): DivideByKeyResultTypes<T>[] => {
  // 🟢 1 — ordenar antes de agrupar
  const sorted = [...array].sort((a: any, b: any) =>
    String(a[field] ?? "").localeCompare(String(b[field] ?? ""), "pt-BR", {
      sensitivity: "base",
    }),
  );

  // 🟢 2 — agrupar
  const map = sorted.reduce((p: Record<string, T[]>, c: any) => {
    const char = String(c[field] ?? "")
      .charAt(0)
      .toUpperCase();

    if (!p[char]) p[char] = [];
    p[char].push(c);

    return p;
  }, {});

  // 🟢 3 — montar resultado
  let result: DivideByKeyResultTypes<T>[] = Object.keys(map).map(k => ({
    letter: k,
    data: map[k],
  }));

  // 🟢 4 — ordenar letras (A,B,C)
  result.sort((a, b) => a.letter.localeCompare(b.letter, "pt-BR"));

  return result;
};

export { sortData, groupByFields, divideByKey };

export const extractParseName = (fullName: string) => {
  if (!fullName) return { firstName: "", lastName: "", shortName: "" };

  const parts = fullName.trim().split(/\s+/); // separa por espaços múltiplos

  const firstName = parts[0];
  const lastName = parts.length > 1 ? parts[parts.length - 1] : "";
  return { firstName, lastName };
};

export const extractShortName = (firstName: string, lastName: string) => {
  const f = firstName?.trim().charAt(0) || "";

  const fl = lastName?.trim()
    ? lastName.trim().charAt(0) // se tem sobrenome → pega 1ª letra
    : firstName?.trim().substring(1, 2) || ""; // se NÃO tem sobrenome → pega 2ª e 3ª letra do firstName

  const shortName = (f + fl).toUpperCase();

  return { shortName };
};

export function extractUrl(text?: string): string | null {
  if (!text) return null;
  const regex = /(https?:\/\/[^\s]+)/i;
  const m = text.match(regex);
  return m ? m[0] : null;
}
